import t from "./ghl-ui.es874.js";
import o from "./ghl-ui.es875.js";
import a from "./ghl-ui.es876.js";
import r from "./ghl-ui.es877.js";
import m from "./ghl-ui.es878.js";
var e = {
  code: "pt-BR",
  formatDistance: t,
  formatLong: o,
  formatRelative: a,
  localize: r,
  match: m,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
};
const p = e;
export {
  p as default
};
